import { render, staticRenderFns } from "./TreatmentProgram.vue?vue&type=template&id=83b1d518"
import script from "./TreatmentProgram.vue?vue&type=script&lang=js"
export * from "./TreatmentProgram.vue?vue&type=script&lang=js"
import style0 from "./TreatmentProgram.vue?vue&type=style&index=0&id=83b1d518&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports